import React, { useState, useEffect } from 'react';
import { corAvatar, iniciais } from '../../utils/chatUtils';

/**
 * Avatar do chat: mostra a FOTO de perfil quando existe; senão, iniciais com cor
 * derivada do id/nome.
 *
 * `fotoUrl` é opcional de propósito — sem ela o componente se comporta como antes,
 * então quem ainda não passa a foto continua funcionando (fallback por iniciais).
 *
 * A foto que não carrega (arquivo sumiu do storage, 404/401) também cai nas iniciais:
 * o pior caso tem que ser o círculo de sempre, nunca o ícone de imagem quebrada.
 */
const Avatar = ({ nome, id, size = 36, fotoUrl }) => {
  const [erro, setErro] = useState(false);
  // Zera ao trocar de URL: o React reaproveita a instância por posição na lista
  // (mensagens/membros), então um erro antigo suprimiria uma foto boa.
  useEffect(() => { setErro(false); }, [fotoUrl]);

  if (fotoUrl && !erro) {
    return (
      <img
        src={fotoUrl}
        alt={nome ? `Avatar de ${nome}` : 'Avatar'}
        title={nome || undefined}
        onError={() => setErro(true)}
        className="rounded-full object-cover flex-shrink-0"
        style={{ width: size, height: size }}
      />
    );
  }
  return (
    <div
      role="img" aria-label={nome ? `Avatar de ${nome}` : 'Avatar'}
      className="flex items-center justify-center rounded-full text-white font-semibold flex-shrink-0"
      style={{ width: size, height: size, background: corAvatar(id || nome), fontSize: size * 0.4 }}
    >
      {iniciais(nome)}
    </div>
  );
};

export default Avatar;
